<template>
  <nav
    v-if="totalPages"
    class="pagination"
  >
    Show
    <v-select
      v-model.number="rowsPerPage"
      :options="perPage"
      class="pagination__select"
      is-mini
      @change="perPageChange"
    />
    <v-button
      :is-disabled="currentPage === 1"
      type="button"
      size="sm"
      class="pagination__nav"
      @click="lastPage"
    >
      <v-icon type="angle-left" />
    </v-button>
    Page
    <v-input
      v-model.number="currentPage"
      class="pagination__input"
      is-mini
      type="number"
      min="1"
      :max="totalPages"
      @input="pageChange"
    />
    / {{ totalPages }}
    <v-button
      :is-disabled="currentPage === totalPages"
      type="button"
      size="sm"
      class="pagination__nav"
      @click="nextPage"
    >
      <v-icon type="angle-right" />
    </v-button>
  </nav>
</template>

<script>
  import Icon from "@/atoms/Icon";
  import Input from "@/atoms/Input";
  import Select from "@/atoms/Select";
  import Button from "@/atoms/Button";

  export default {
    components: {
      "v-icon": Icon,
      "v-input": Input,
      "v-button": Button,
      "v-select": Select
    },
    props: {
      count: {
        type: Number,
        default: 1
      },
      initialCurrentPage: {
        type: [Number,String],
        default: 1
      },
      initialRowsPerPage: {
        type: [Number,String],
        default: 5
      },
      pageChanged: {
        type: Function,
        default: () => {
        }
      },
      perPageChanged: {
        type: Function,
        default: () => {
        }
      },
      perPage: {
        type: Array,
        default: () => [
          {
            label: "5",
            value: 5
          },
          {
            label: "10",
            value: 10
          },
          {
              label: "20",
              value: 20
          },
          {
            label: "30",
            value: 30
          },
          {
            label: "50",
            value: 50
          }]
      },
    },
    data() {
      return {
        rowsPerPage: this.initialRowsPerPage,
        currentPage: this.initialCurrentPage
      }
    },
    computed: {
      totalPages: {
        get: function () {
          return Math.ceil(this.count / this.rowsPerPage)
        },
        set: function (newValue) {

        }
      }
    },
    watch: {
      //when the filter changes total number of rows, reset pagination
      count: function () {
        this.pageChange(1);
      }
    },
    mounted() {
      this.perPageChange(this.rowsPerPage);
      this.pageChange(this.currentPage);
    },
    methods: {
      pageChange(page) {
        let curPage = parseInt(page);
        if (page > this.totalPages) {
          curPage = this.totalPages
        }
        if (page < 1) {
          curPage = 1
        }
        this.currentPage = curPage;
        this.pageChanged({currentPage: curPage});
      },
      perPageChange(customPerPage) {
        this.perPageChanged({currentPerPage: customPerPage});
        this.rowsPerPage = customPerPage;
        this.pageChange(1);
      },
      lastPage() {
        this.pageChange(this.currentPage - 1);
      },
      nextPage() {
        this.pageChange(this.currentPage + 1);
      }
    }
  };

</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: $font-size-sm;
    &__select {
      margin: 0 5px;
      width: 4rem;
    }
    &__input {
      margin: 0 5px;
      width: 2rem;
      padding-left: 2px;
      padding-right: 2px;
      text-align: center;
    }
    &__nav {
      &:first-of-type {
        margin-right: 5px;
      }
      &:last-of-type {
        margin-left: 5px;
      }
    }
  }
</style>
